import { RootState } from 'store';

const LeaveRequestsLookupState = (state: RootState) => state.lookups.leaveRequests;

export const selectLeaveRequests = (state: RootState) => LeaveRequestsLookupState(state).rows;
